import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { Alert } from '../components/Alert';
import { AuthLayout } from '../components/AuthLayout';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { messageForError } from '../lib/errors';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const { refresh, auth } = useAuth();
  const [state, setState] = useState<'working' | 'done' | 'error'>(token ? 'working' : 'error');
  const [error, setError] = useState<string | null>(
    token ? null : 'This link is missing its token.',
  );
  const ran = useRef(false);

  useEffect(() => {
    if (!token || ran.current) return;
    ran.current = true;
    api.auth
      .verifyEmail({ token })
      .then(async () => {
        setState('done');
        await refresh();
      })
      .catch((err: unknown) => {
        setError(messageForError(err));
        setState('error');
      });
  }, [token, refresh]);

  return (
    <AuthLayout title="Verify your email">
      {state === 'working' ? (
        <p className="text-center text-sm text-muted" aria-busy>
          Checking your link…
        </p>
      ) : null}
      {state === 'done' ? (
        <Alert tone="success">Your email is confirmed. Your account is ready to use.</Alert>
      ) : null}
      {state === 'error' && error ? <Alert tone="error">{error}</Alert> : null}
      <Link
        to={auth.status === 'authed' ? '/' : '/login'}
        className="text-center font-medium text-brand underline-offset-2 hover:underline"
      >
        {auth.status === 'authed' ? 'Continue' : 'Sign in'}
      </Link>
    </AuthLayout>
  );
}
